import { Actions, Module, Mutations } from 'vuex-smart-module'

import { AuthCardInfo, CardInfo, CardsService, ChangeStatusRequest } from '@/api'
import { loading as loadingModule, LoadingGetters } from '@/store/modules/loading'

const loading = loadingModule.clone()

export class CardsState {
  cardList: Array<AuthCardInfo> = []
  cardToEdit: CardInfo = null
}

export class CardsGetters extends LoadingGetters<CardsActions, CardsState> {
  get isCardListGet() {
    return this.state.loading.loaders.getCardList
  }
}

export class CardsMutations extends Mutations<CardsState> {
  setCardList(cardList: Array<AuthCardInfo>) {
    this.state.cardList = cardList || []
  }
}

export class CardsActions extends Actions<CardsState, CardsGetters, CardsMutations, CardsActions> {
  async checkCardsActive(): Promise<boolean> {
    await CardsService.checkCardsActive()
    return true
  }

  async getCardList() {
    const { list } = await CardsService.getCardsList()
    this.mutations.setCardList(list)
  }

  async changeCardStatus(body: ChangeStatusRequest) {
    await CardsService.changeCardStatus(body)
    await this.actions.getCardList()
  }
}

export type CardsModules = {
  loading: typeof loading
}

export const cards = new Module<CardsState, CardsGetters, CardsMutations, CardsActions, CardsModules>({
  state: CardsState,
  getters: CardsGetters,
  mutations: CardsMutations,
  actions: CardsActions,
  modules: {
    loading,
  },
})
